var scope_0 = require('/home/travis/build/dcm-2020/dcm-2020.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/home/travis/build/dcm-2020/dcm-2020.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/850cad33cf0faee25b2f1a17b84febd2.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    